import { useCallback, useEffect, useMemo, useState } from 'react';

import throttle from 'lodash/throttle';

export const useViewportSizing = () => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const isMobile = useMemo(() => windowSize.width < 768, [windowSize.width]);
  const isTablet = useMemo(() => windowSize.width >= 768 && windowSize.width < 1024, [windowSize.width]);
  const isDesktop = useMemo(() => windowSize.width >= 1024, [windowSize.width]);
  const isSmallDesktop = useMemo(() => windowSize.width >= 1024 && windowSize.width < 1280, [windowSize.width]);
  const isNormalDesktop = useMemo(() => windowSize.width >= 1280, [windowSize.width]);
  const isMediumDesktop = useMemo(() => windowSize.width >= 1280 && windowSize.width < 1440, [windowSize.width]);

  // eslint-disable-next-line
  const handleResize = useCallback(
    throttle(
      () =>
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        }),
      200,
    ),
    [],
  );

  useEffect(() => {
    if (process.browser) {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }

    return undefined;
  }, [handleResize]);

  return {
    windowSize,
    isMobile,
    isTablet,
    isDesktop,
    isSmallDesktop,
    isNormalDesktop,
    isMediumDesktop,
  };
};
